import { type ReactNode } from 'react';

export type CallRailReadyGateProps = {
  children: ReactNode;
};

export type CallRailProviderProps = {
  enabled: boolean;
  fallbackMs?: number;
  children: ReactNode;
};

export const CALLRAIL_SWAP_EVENT = 'callTrkSwapOccured';

export type CallRailContextValue = {
  callRailReady: boolean;
  hasCallRailIntegration: boolean;
};
